<template>
    <section class="blocation_edit">
        <div class="comp_scroller">
            <div class="comp_content" :class="{'state-loading':!data}">
                <template v-if="data">
                    <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle">
                        <div class="col">
                            <h1 class="part_ui_heading"><span>{{ $t('blocation') }}/{{ $t('rooms_state_fault') }}</span>
                            </h1>
                        </div>
                    </header>
                    <div class="wrp_comp_body" v-on:scroll="handleGlobalScroll($event)">
                        <div class="info-row">
                            <room-label :label="data.roomLabel"/>
                        </div>
                        <div class="items">
                            <edit-item :label="$t('reason')" labelFor="note" style="margin-bottom: 25px">
                                <div class="part_ui_input part_ui_textarea">
                                    <textarea type="date" id="note" v-model="data.title" ref="note"
                                              style="text-align: right"
                                              v-autosize="data.title"
                                              disabled/>
                                </div>
                            </edit-item>
                            <edit-item :label="$t('from')">
                                <div class="part_ui_input">
                                    <date-input v-model="data.fromDate" required disabled/>
                                </div>
                            </edit-item>
                            <edit-item :label="$t('to')" style="margin-bottom: 25px">
                                <div class="part_ui_input">
                                    <date-input v-model="data.toDate" required disabled/>
                                </div>
                            </edit-item>
                            <edit-item :label="$t('out_of_order')">
                                <label class="part_ui_switch">
                                    <input type="checkbox" v-model="data.outOfOrder" disabled>
                                    <span></span>
                                </label>
                            </edit-item>
                            <edit-item :label="$t('finalize')">
                                <label class="part_ui_switch">
                                    <input type="checkbox" v-model="data.closed" disabled>
                                    <span></span>
                                </label>
                            </edit-item>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment/moment';

export default {
    name: 'blocation-edit',
    data() {
        return {
            moment: moment,
            data: undefined,
            dateString: undefined,
            roomId: undefined
        }
    },
    mounted() {
        this.roomId = this.$route.params.roomId;
        this.dateString = moment(this.$route.params.date).format('YYYY-MM-DD');
        this.loadData()
    },
    methods: {
        async loadData() {
            let query = `{
                    listRoomBlocks(room_id: ${this.roomId}, target_date: "${this.dateString}:${this.dateString}") {
                        items {
                            id
                            room_id
                            from_date
                            to_date
                            title
                            closed
                            out_of_order
                            room {
                                code
                            }
                        }
                    }
            }`;
            await axios({
                data: query
            }).then(async (response) => {
                let res = response.data.data.listRoomBlocks;
                const blocation = res.items[0]
                this.data = {
                    id: blocation.id,
                    fromDate: blocation.from_date ? moment(blocation.from_date).toDate() : undefined,
                    toDate: blocation.to_date ? moment(blocation.to_date).toDate() : undefined,
                    title: blocation.title,
                    closed: blocation.closed,
                    outOfOrder: blocation.out_of_order,
                    roomLabel: blocation.room.code
                }
            }).catch(error => {
                this.showError(error)
            });
        },
    }
}
</script>

<style scoped lang="less">
@import "../../less/_core/global/font_sizes.less";
@import "../../less/_core/theme/core/colors.less";

header {
    margin-bottom: 2px;
}

.comp_content {
    min-height: 100%; // TODO kvůli loadingu. asi pryč?
    display: flex;
    flex-direction: column;
}

.items {
    margin-top: 27px
}

.info-row {
    display: flex;
    margin-bottom: 10px;
    margin-top: 10px;

    .cell {
        display: flex;
        flex: 1;
        justify-content: flex-start;

        .content {
            display: flex;
            align-items: center;
            flex: 1;
        }
    }
}

input:disabled {
    color: @color-brown-light !important
}

.part_ui_textarea {
    align-self: stretch;

    textarea {
        display: block;
        font-size: @18;
        line-height: 1.5;
        color: @color-brown-light;
        padding: 0 4px;
    }
}
</style>



// WEBPACK FOOTER //
// src/templates/comp/blocation-edit.vue